import api from './api';
import { Store } from '../types';

interface StoreResponse {
  stores: Store[];
  total: number;
}

export const storeService = {
  async getAllStores(filters?: {
    name?: string;
    page?: number;
    limit?: number;
  }): Promise<StoreResponse> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });
    }
    const response = await api.get(`/stores?${params.toString()}`);
    return response.data;
  },

  async getStoresByAssociation(filters?: {
    name?: string;
    page?: number;
    limit?: number;
  }): Promise<StoreResponse> {
    console.log('🔍 Frontend StoreService - Buscando lojas da associação com filtros:', filters);
    
    try {
      // 🛡️ CORREÇÃO: Usar endpoint direto /stores que já filtra por associação
      const params = new URLSearchParams();
      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined) {
            params.append(key, value.toString());
          }
        });
      }
      
      const url = `/stores${params.toString() ? `?${params.toString()}` : ''}`;
      console.log('🌐 Frontend StoreService - Fazendo requisição para:', url);
      
      const response = await api.get(url);
      console.log('✅ Frontend StoreService - Resposta recebida:', response.data);
      
      return response.data;
      
    } catch (error) {
      console.error('❌ Erro ao buscar lojas da associação:', error);
      throw error;
    }
  },

  async getStoreById(id: string): Promise<Store> {
    const response = await api.get(`/stores/${id}`);
    return response.data;
  },

  async createStore(store: Omit<Store, 'id' | 'createdAt' | 'updatedAt'>): Promise<Store> {
    const response = await api.post('/stores', store);
    return response.data;
  },

  async updateStore(id: string, store: Partial<Store>): Promise<Store> {
    const response = await api.put(`/stores/${id}`, store);
    return response.data;
  },

  async deleteStore(id: string): Promise<void> {
    await api.delete(`/stores/${id}`);
  }
};
